import { render, staticRenderFns } from "./FinancialCategoryTransfer.vue?vue&type=template&id=2998fbd9&scoped=true"
import script from "./FinancialCategoryTransfer.vue?vue&type=script&lang=js"
export * from "./FinancialCategoryTransfer.vue?vue&type=script&lang=js"
import style0 from "./FinancialCategoryTransfer.vue?vue&type=style&index=0&id=2998fbd9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2998fbd9",
  null
  
)

export default component.exports